import React from "react";
import ComplianceSection from "../../components/ComplianceSection/ComplianceSection";

const FinancialCompliance = () => {
  return <ComplianceSection />;
};

export default FinancialCompliance;
